import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { shiftActions } from "../../sagas/shiftSlice";
import { FaSignOutAlt } from "react-icons/fa";

const OpenShiftModal = ({ commercialId, onOpenShift, onLogout }) => {
  const dispatch = useDispatch();
  const { currentShift, loading } = useSelector((state) => state.shift);
  const [isOpen, setIsOpen] = useState(false);


  useEffect(() => {
    if (!loading) {
      if (!currentShift || currentShift.status === "CLOSED") {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    }
  }, [loading, currentShift]);

  const handleStartShift = () => {
    onOpenShift();
    setIsOpen(false)
  };

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      centered
      modalClassName="custom-open-shift-modal"
    >
      <ModalHeader className="text-center">
        🔓 Ouvrir un nouveau shift
      </ModalHeader>

      <ModalBody className="text-center">
        <p className="mb-1">
          <strong>Aucun shift ouvert</strong>
        </p>
        <p className="small text-muted">
          Vous devez ouvrir un nouveau shift pour accéder à la caisse.
        </p>
      </ModalBody>

      <ModalFooter className="d-flex justify-content-between">
        {/* Logout */}
        <Button
          color="outline-danger"
          onClick={onLogout}
          title="Se déconnecter"
        >
          <FaSignOutAlt className="me-2" />
          Déconnexion
        </Button>

        {/* Open Shift */}
        <Button
          color="outline-success"
          onClick={handleStartShift}
        >
          Commencer
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OpenShiftModal;
